module.exports = __webpack_public_path__ + "img/cw_yf_faPiaoGuanLi.be4ad3c4.svg";